module.exports = "https://cdn.realtymogul.com/static/media/RP_lakeside_at_town.69724d87.jpg";